import { render } from "./ComunicationView.vue?vue&type=template&id=e3fc5bc0"
import script from "./ComunicationView.vue?vue&type=script&lang=js"
export * from "./ComunicationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__